module.exports = __webpack_public_path__ + "static/media/S2N8-3.895a6dad.svg";